import { useState, useEffect } from 'react';
import { Flex } from './TremorCompat';
import { DatePicker, Panel, Text } from 'rsuite';

import { makeDateFromTime, makeTimeFromDate } from '../utils/registerTime';
import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplayStartStopTimePickerItem = ({
  register,
  tc,
  register2,
  icon,
  onChange,
  onChange2,
  disabled,
  borderOff,
}) => {
  const [value, setValue] = useState(/** @type {any} */ (null));
  const [value2, setValue2] = useState(/** @type {any} */ (null));

  // pickedDate is a Date|null from the DatePicker — a different domain than
  // the packed hi/lo integers value/value2 above; kept distinctly named so
  // the two representations can't get mixed up in a future edit.
  const updateValue = (pickedDate, event) => {
    devLog('Date time start picker Changed', event, pickedDate);
    // rsuite's DatePicker is cleanable by default — clearing it calls onChange
    // with null. Packing that would resolve to a real 00:00, silently writing
    // midnight to the device register; treat clearing as a no-op instead.
    if (pickedDate === null) {
      return;
    }
    setValue(makeTimeFromDate(pickedDate));
    onChange(register, pickedDate);
  };
  const updateValue2 = (pickedDate, event) => {
    devLog('Date time stop Changed', event, pickedDate);
    if (pickedDate === null) {
      return;
    }
    setValue2(makeTimeFromDate(pickedDate));
    onChange2(register2, pickedDate);
  };

  useEffect(() => {
    setValue2(register2.value);
  }, [register2.value]);

  useEffect(() => {
    setValue(register.value);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4 ">
        <DisplayIcon icon={icon} />
        <div className="truncate space-y-0.5 w-1/4">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
        </div>

        <div className="truncate space-y-0.5 w-3/4 ">
          <Flex justifyContent="end" className="space-x-4">
            <Text color={tc} className="">
              Start:{' '}
            </Text>
            <DatePicker
              format="HH:mm"
              ranges={[]}
              size="sm"
              value={makeDateFromTime(value)}
              onChange={updateValue}
              disabled={disabled}
              cleanable={false}
            />
            <Text color={tc} className="">
              Stop:{' '}
            </Text>
            <DatePicker
              format="HH:mm"
              ranges={[]}
              size="sm"
              value={makeDateFromTime(value2)}
              onChange={updateValue2}
              disabled={disabled}
              cleanable={false}
            />
          </Flex>
        </div>
      </Flex>
    </Panel>
  );
};
